/**
 * Activity log UI labels only (no Prisma / server code).
 * Safe to import from client components and from app/api/activity-log/route.ts.
 */

import type {
  ActivityActionTypeValue,
  ActivityPathValue,
  ActivityResultValue,
} from "@/types/activity-log";

export const ACTIVITY_ACTION_TYPE_LABELS: Record<
  ActivityActionTypeValue,
  string
> = {
  CONNECTION: "Connexion",
  DISCONNECTION: "Déconnexion",
  ACCESS_DENIED: "Tentative d'accès non autorisée",
  KVPS_CHANGE: "Changement KVPS",
  VEHICLE_SEARCH_INIT: "Init recherche véhicule",
  DRAFT_CREATE: "Création brouillon",
  DRAFT_UPDATE: "Modification brouillon",
  DRAFT_DELETE: "Suppression brouillon",
  CTM_VALIDATION: "Validation CTM",
  IMPORT_FILE_RCE_CNIT: "Import fichiers RCE/CNIT",
  RCE_CNIT_UPDATE: "Modification RCE/CNIT",
  RCE_CNIT_DELETE: "Suppression RCE/CNIT",
  USER_AGREEMENT_CREATE: "Création agrément/habilitation",
  USER_AGREEMENT_UPDATE: "Modification agrément/habilitation",
  USER_AGREEMENT_DEACTIVATE: "Désactivation agrément/habilitation",
  USER_AGREEMENT_ACTIVATE: "Activation agrément/habilitation",
  RAPPROCHEMENT_MANUAL: "Rapprochement manuel d'un VIN",
  ECOC_IMPORT_RELANCE: "Relance en masse ECOC / COC",
  ECOC_BATCH_RELANCE: "Batch relance ECOC / COC",
  CAR_VIEW_STATUS_CHECK: "Consultation véhicule",
  RAPPROCHEMENT_BATCH: "Rapprochement automatique eCOC et RCE/CNIT",
  FDM_REQUESTS_IMPORT: "Demande en masse FDM",
  FDM_REQUEST_CREATE: "Demande FDM",
};

export const ACTIVITY_RESULT_LABELS: Record<ActivityResultValue, string> = {
  OK: "OK",
  KO_METIER: "KO métier",
  KO_TECH: "KO technique",
};

export const ACTIVITY_PATH_LABELS: Record<ActivityPathValue, string> = {
  AVS: "AVS",
  RETAIL: "Retail",
  SYSTEM: "Système",
};

export function getActionTypeLabel(
  actionType: ActivityActionTypeValue | null,
): string {
  return actionType
    ? (ACTIVITY_ACTION_TYPE_LABELS[actionType] ?? actionType)
    : "—";
}

export function getResultLabel(result: ActivityResultValue | null): string {
  return result ? (ACTIVITY_RESULT_LABELS[result] ?? result) : "—";
}

export function getPathLabel(path: ActivityPathValue | null): string {
  return path ? (ACTIVITY_PATH_LABELS[path] ?? path) : "—";
}
